module.exports = __webpack_public_path__ + "static/predictivepoem 8-01-4d5aa7cfef5763e97a8b4f19c391eab2.jpg";